import { h, Component } from 'preact'
import PostSlide from '../components/PostSlide'
import ErrorMessage from '../components/ErrorMessage'
import Loader from '../components/Loader'
// Tell Babel to transform JSX into h() calls:
/** @jsx h */

class PostSlider extends Component {

  constructor(props) {
    super(props)
    this.state = {
      pos: 0,
      shown: 0,
      slideWidth: 0,
      sliderWidth: 0,
      sliderScrollWidth: 0,
      nextActivity: 'inactive',
      prevActivity: 'inactive',
      sliderStyle: ''
    }

    this.setValues = this.setValues.bind(this)
    this.handlePrev = this.handlePrev.bind(this)
    this.handleNext = this.handleNext.bind(this)
    this.setTransform = this.setTransform.bind(this)
    this.goPrev = this.goPrev.bind(this)
    this.goNext = this.goNext.bind(this)
    this.navActivity = this.navActivity.bind(this)
  }

  componentDidMount() {
    this.setValues()
    document.addEventListener('keydown', e => this.handleKeydown(e), false )
    window.addEventListener('resize', this.setValues)
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', e => this.handleKeydown(e), false )
    window.removeEventListener('resize', this.setValues)
  }

  setValues() {
    const slider = document.querySelector('.js-product-slider')
    const firstSlide = document.querySelector('.js-product-slide')

    if ( slider && firstSlide ) {
      this.setState( () => {
        return {
          pos: 0,
          shown: slider.offsetWidth,
          slideWidth: firstSlide.offsetWidth,
          sliderWidth: slider.offsetWidth,
          sliderScrollWidth: slider.scrollWidth
        }
      }, this.setTransform ) 
    }
  }

  handlePrev() {
    this.goPrev()
  }

  handleNext() {
    this.goNext()
  }

  handleKeydown(e) {
    if (e.keyCode === 39) {
      this.goNext()
    }
    if (e.keyCode === 37) {
      this.goPrev()
    }
  }

  setTransform() {
    let nr = this.state.pos * this.state.slideWidth

    this.setState( () => {
      return {
        sliderStyle: `transform: translate3d(-${nr}px,0,0)`
      }
    }, this.navActivity ) 
  }

  goPrev() {
    if (this.state.pos > 0) {
      this.setState( () => {
        return {
          pos: Math.max(this.state.pos - 1, 0),
          shown: this.state.shown - this.state.slideWidth
        }
      }, this.setTransform ) 
    }
  }

  goNext() {
    if (this.state.shown < this.state.sliderScrollWidth) {
      this.setState( () => {
        return {
          pos: Math.min(this.state.pos + 1, this.props.slidesCount - 1),
          shown: this.state.shown + this.state.slideWidth
        }
      }, this.setTransform ) 
    }
  }

  navActivity() {
    // Can we still go previous?
    if (this.state.pos > 0) {
      this.setState({ prevActivity: 'active' })
    } else {
      this.setState({ prevActivity: 'inactive' })
    }
    // Can we still go next?
    if ( this.state.shown < this.state.sliderScrollWidth ) {
      this.setState({ nextActivity: 'active' })
    } else {
      this.setState({ nextActivity: 'inactive' })
    }
  }

  render() {

    if (this.props.error) {
      return <ErrorMessage type="filter-error" />
    }

    if (this.props.isLoading) {
      return <Loader />
    }

    return (
      <div className="c-product-slider-parent">

        <div className="c-product-slider js-product-slider" style={this.state.sliderStyle}>
          {
            this.props.posts.map((post) => {
              return <PostSlide post={post} key={post.id} />
            })
          }

          <div className="c-product-slider__filler"></div>
        </div>
        
        <div onClick={this.handlePrev} className={`c-product-slider-nav c-product-slider-nav--prev ${this.state.prevActivity}`}>
          <svg class="c-icon c-product-slider-nav__icon">
            <use href="#slider-chevron-left" xlinkHref="#slider-chevron-left"></use>
          </svg>
        </div>

        <div onClick={this.handleNext} className={`c-product-slider-nav c-product-slider-nav--next ${this.state.nextActivity}`}>
          <svg class="c-icon c-product-slider-nav__icon">
            <use href="#slider-chevron-right" xlinkHref="#slider-chevron-right"></use>
          </svg>
        </div>

      </div>
    )
  }
}

export default PostSlider



// WEBPACK FOOTER //
// ./src/js/products/containers/PostSlider.js